import React from 'react';
import { Link } from 'react-router-dom';

/**
 * SPLICEWebサイトフッターコンポーネント
 * 会社情報リンクを含む
 */
const Footer: React.FC = () => {
  return (
    <footer className="border-top bg-white py-3 mt-auto">
      <div className="container-fluid">
        <div className="d-flex justify-content-end">
          <div className="d-flex align-items-center gap-2">
            <Link 
              to="/company" 
              className="text-muted text-decoration-none small"
            >
              会社概要
            </Link>
            <span className="text-muted small">|</span>
            <Link 
              to="/transaction-law" 
              className="text-muted text-decoration-none small"
            >
              特定商取引法に基づく表記
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 